export { default } from '@mui/material/InputAdornment';
